import app from 'flarum/forum/app';
import Notification from 'flarum/components/Notification';
// import { isPermanentSuspensionDate } from '../helpers/suspensionHelper';

export default class PushFrontedNotification extends Notification {
  icon() {
    return '';
  }

  img() {
    return `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-zt-tj.png`;
  }

  href() {
    let post = this.attrs.notification.subject();
    if (!post) {
      return;
    }
    let addExp = this.attrs.notification.content().myObject.addExperience;
    let addIntegra = this.attrs.notification.content().myObject.addIntegra;
    post.addExp = addExp;
    post.addIntegra = addIntegra;
    return app.route.post(post);
  }

  content() {
    const notification = this.attrs.notification;
    let username = notification.fromUser().username();
    let title = notification.content().discussion.title;
    let addExp = notification.content().myObject.addExperience;
    let addIntegra = notification.content().myObject.addIntegra;

    return app.translator.trans('dl_discussion_controller.forum.notices.admin_text',
    {username:username,title:title,addExp:addExp,addIntegra:addIntegra});

  }
}
